import { from, of } from "rxjs";
import { ofType } from "redux-observable";
import { mergeMap, catchError } from "rxjs/operators";

import { imageUploadError, imageUploadComplete, getParticipantProfileRequest } from "../_actions";

import { commonConstants } from "../_constants";

export const imageUploadCommonEpic = (actions$) => {
    return actions$.pipe(
        ofType(commonConstants.IMAGE_UPLOAD_REQUEST),
        mergeMap((action) => {
            const formData = new FormData();

            formData.append("file", action.payload.file);

            //TODO need to take url from config value

            return from(
                fetch("/api/auth/upload-profile-pic", {
                    method: "POST",
                    body: formData,
                }),
            ).pipe(
                mergeMap((response) => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return from(response.json()).pipe(
                        mergeMap((responseData) => {
                            action.payload.setCropImageArea(false);
                            return of(
                                getParticipantProfileRequest(),
                                imageUploadComplete({
                                    response,
                                }),
                            );
                        }),
                        catchError((error) => of(imageUploadError(error))),
                    );
                }),
                catchError((error) => of(imageUploadError(error))),
            );
        }),
    );
};
